// if this value changes, tailwind.config.js safelist must be updated
export const TRANSITION_DURATION = 700
